module.exports = __webpack_public_path__ + "static/media/successBg.4ceaeec9.png";